
/**
 * @module toxi/math/waves/WaveState
 */
var	WaveState = function(phase,frequency,amp,offset){
	this.phase = phase;
	this.frequency = frequency;
	this.amp = amp;
	this.offset = offset;
};

module.exports = WaveState;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/math/waves/WaveState.js
// module id = 3095
// module chunks = 15